import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type ExportState = {
  exportModels: string[];
  addExportModel: (modelId: string) => void;
  deleteExportModel: (modelId: string) => void;
};

export const useExportStore = create<ExportState>()(
  devtools((set) => ({
    exportModels: [],
    addExportModel: (modelId: string) =>
      set(
        (state) => ({ exportModels: [...state.exportModels, modelId] }),
        undefined,
        'export/add',
      ),
    deleteExportModel: (modelId: string) =>
      set(
        (state) => ({
          exportModels: state.exportModels.filter((id) => id !== modelId),
        }),
        undefined,
        'export/delete',
      ),
  })),
);
